import { Component, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { NzIconModule } from 'ng-zorro-antd/icon';

@Component({
  selector: 'app-terms',
  imports: [NzIconModule, TranslateModule],
  templateUrl: './terms.component.html',
  styleUrl: './terms.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TermsComponent {
  constructor(private router: Router) {}

  protected back(): void {
    this.router.navigate(['/symptom-assessment/new-valutation']);
  }
}
